import React from "react";
import "./Footer.css";
import "font-awesome/css/font-awesome.min.css";

const Footer = () => {
  return (
    <>
      <div style={{ backgroundColor: "#212529"}}>
        
        <div style={{color:"white",padding:"10px",textAlign:"center"}}>
          Created By Lov kumar | © 2023. All Rights Reserved
        </div>
      </div>
    </>
  );
};

export { Footer };
